import PropTypes from 'prop-types'
import styled, { keyframes } from 'styled-components'
import IconSpinner from 'components/Icons/IconSpinner'

const spinningAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const Loading = styled(IconSpinner)`
  animation: ${spinningAnimation} ${props => props.duration}ms linear 0s infinite;
`
Loading.propTypes = {
  ...IconSpinner.propTypes,
  duration: PropTypes.number // in ms
}
Loading.defaultProps = {
  duration: 1000
}

export default Loading
